/**
 * Parser estricto de montos: solo acepta un number finito o un string con
 * trim() no vacio que parsee a numero finito. Nunca coerciona ' ', '', [],
 * false o NaN a un cero falso: un dato ausente/invalido NO es un monto conocido.
 */
export function parseStrictAmount(value: unknown): number | null {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '') {
      return null;
    }
    const amount = Number(trimmed);
    return Number.isFinite(amount) ? amount : null;
  }
  return null;
}

/** 0.00 solo para cero conocido; ausente/invalido se muestra como '—'. */
export function formatStrictAmount(value: unknown): string {
  const amount = parseStrictAmount(value);
  return amount === null ? '—' : amount.toFixed(2);
}
